import gql from 'graphql-tag';
import { PAGINATION_VIEW_MODEL_FRAGMENT } from 'shared';

export const GET_PRODUCT_CHANGELOG = gql`
  ${PAGINATION_VIEW_MODEL_FRAGMENT}
  query ProductChangelog($input: AftermarketProductChangelogInput!) {
    result: aftermarketProductChangelog(input: $input) {
      error
      success

      pagination {
        ...PaginationMetaViewModel
      }

      items {
        id
        changes
        productId
        changeType
        createdDateTime
        modifiedBy {
          id
          fullName
        }
      }
    }
  }
`;
